
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reduce-image-size",
      function () {
        return require("private-next-pages/reduce-image-size/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reduce-image-size"])
      });
    }
  